<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.removeAccessPlaybookAction.title' | labelsProvider }}
    </div>
    <div class="disclaimer">
      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.removeAccessPlaybookAction.actionOverviewHeader' | labelsProvider }}
      </div>
      <div>
        {{ 'commonActions.removeAccessPlaybookAction.actionOverviewTitle' | labelsProvider }}
      </div>
      <div>
        <ol>
          <li>
            {{ 'commonActions.removeAccessPlaybookAction.actionOverviewDescription.guestAccess' | labelsProvider }}
          </li>
          <li>
            {{ 'commonActions.removeAccessPlaybookAction.actionOverviewDescription.tenantWideAccess' | labelsProvider }}
          </li>
        </ol>
      </div>
      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.removeAccessPlaybookAction.howItWorksHeader' | labelsProvider }}
      </div>
      <div class="how-it-works-description">
        {{ 'commonActions.removeAccessPlaybookAction.howItWorksDescription' | labelsProvider }}
      </div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="supported-rules-header">
                {{ 'commonActions.removeAccessPlaybookAction.supportedRulesHeader' | labelsProvider }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <li *ngFor="let rule of supportedRulesIdAndDescription" class="disclaimer-rules">
            {{ rule }}
          </li>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.removeAccessPlaybookAction.limitationsHeader' | labelsProvider }}
      </div>
      <div class="disclaimer-limitation">
        {{ 'commonActions.removeAccessPlaybookAction.limitationsDisclaimer' | labelsProvider }}
      </div>
    </div>
  </div>
</div>
